import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const foroomsApi = api
  .enhanceEndpoints({ addTagTypes: ['FORooms'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFORoomss: builder.query<any[], string>({
        query: cid => `forooms/${cid}`,
        providesTags: ['FORooms'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (
                data.type === 'FRONT_OFFICE_UPDATED' ||
                data.type === 'POS_ORDER_UPDATED'
              ) {
                dispatch(foroomsApi.util.invalidateTags(['FORooms']));
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getFOVacantRooms: builder.query<any, string>({
        query: id => `forooms/byvacant/${id}`,
        providesTags: ['FORooms']
      }),
      getFOVacantRoomsEd: builder.query<any, any>({
        query: ({ cid, checkin }) => `forooms/byvacanted/${cid}/${checkin}`,
        providesTags: ['FORooms']
      }),
      getFORoomsById: builder.query<any, string>({
        query: id => `forooms/byid/${id}`,
        providesTags: ['FORooms']
      }),
      insertFORooms: builder.mutation({
        query: forooms => ({
          url: `forooms/`,
          method: 'POST',
          body: forooms
        }),
        invalidatesTags: ['FORooms']
      }),
      updateFORooms: builder.mutation({
        query: forooms => ({
          url: `forooms/`,
          method: 'PUT',
          body: forooms
        }),
        invalidatesTags: ['FORooms']
      }),
      deleteFORooms: builder.mutation({
        query: forooms => ({
          url: `forooms/${forooms.rm_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FORooms']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFORoomssQuery,
  useGetFOVacantRoomsQuery,
  useGetFOVacantRoomsEdQuery,
  useGetFORoomsByIdQuery,
  useInsertFORoomsMutation,
  useUpdateFORoomsMutation,
  useDeleteFORoomsMutation
} = foroomsApi;

